module.exports = __webpack_public_path__ + "img/s4.e37ed2e1.png";